export default {
  init() {
    // JavaScript to be fired on all pages
    window.$ = jQuery; // make sure jQuery is defined

    // secondary menu workaround
    // moves title tag content to style as background image
    $('.js-title-to-bgimg').each(function(){
      let img = $(this).find('a').eq(0).attr('title');
      $(this).find('a').eq(0).attr('title','');
      let path = '/wp-content/uploads/' + img;
      let css = 'url(' + path + ')';
      $(this).css('background-image', css);
    });
    $('#nav-secondary').css('visibility', 'visible');

    // intro text
    function alignIntroText(){
      $('.intro-text').each(function(){
        if ($('#nav-secondary').is(':visible')) {
          let offset = $(this).height();
          let next = $('#logo-primary');
          offset -= next.outerHeight(true) - (next.outerHeight(true) - next.height()) / 2;
          next = $('#nav-secondary ul.nav li:first-child');
          offset -= next.height();
          $(this).css('margin-top',-offset);
        } else {
          $(this).css('margin-top','');
        }
      });
    }

    alignIntroText();
    $(window).resize(alignIntroText);

    // slidable function
    function accordion(element, time, delay=0, condition=true, ignoreHidden=false) {
      let height = 0;
      element.children().each(function () {
        height += $(this).height();
      });
      let isHidden = element.hasClass('hidden');
      if (condition && (ignoreHidden || isHidden)) {
        element.stop().delay(delay).animate({
          height: height,
        }, time, function () {
          element.removeClass('hidden');
          element.css('height', 'auto');
        });
      } else if (ignoreHidden || !isHidden) {
        element.stop().delay(delay).animate({
          height: 0,
        }, time, function () {
          element.addClass('hidden');
        });
      }
    }

    // navigation add mobile button
    $('#nav-primary nav').append('<div id="nav-mobile"><button></button></div>');
    let nav = $('#nav-primary nav ul.nav');
    let navsubs = nav.find('ul');
    let time = 1000;
    let mobileIsVisible = function(){ return $('#nav-mobile').is(':visible'); };
    let navIsHidden = function(){ return $('#nav-primary nav ul.nav').hasClass('hidden'); };
    accordion(nav, 0, 0, !mobileIsVisible(), true);
    navsubs.addClass('hidden');
    $('#nav-mobile button').click(function(){
      if (navIsHidden()){
        accordion(navsubs, time,0, false, true);
      }
      accordion(nav, time, 0);
    });
    navsubs.siblings('a').click(function(){
      accordion($(this).siblings('ul'),time);
    });
    $(window).resize(function(){
      if (!mobileIsVisible()){
        if (navIsHidden()){
          accordion(nav, 0, 0, true, false);
        }
      } else {
        if(!navIsHidden()){
          nav.addClass('hidden');
          navsubs.addClass('hidden');
          accordion(navsubs, time, 0, false, true);
          accordion(nav, time, time, false, true);
        }
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js